export const multiFilters = (list, filters) => {
  // no filters
  if (!filters || typeof filters !== 'object') return list

  const filterKeys = Object.keys(filters);

  // no filters
  if (!filterKeys.length) return list

  return list.filter((item) => {
    let result = false

    if(Array.isArray(filters)){
      result = filters.some((filter) => {
        return filterItem(item, filter)
      })
    } else if(typeof(filters) === 'object'){
      result = filterItem(item, filters)
    }

    return result
  });
}

const filterItem = (item, filter) => {
  const filterKeys = Object.keys(filter);

  return filterKeys.every(key => {
    if(filter[key] === null){
      return item[key] === null
    } else if(typeof filter[key] === 'string'){
      const resultCond = checkCondition(item[key], filter[key])
      if(resultCond !== -1) {
        return resultCond
      }
    } else if (Array.isArray(filter[key])){
      return filter[key].includes(item[key]);
    } else if (typeof filter[key] === 'object') {
      const subFilterKeys = Object.keys(filter[key])

      if (!subFilterKeys.length) return true

      return subFilterKeys.every(subKey => {
        if (!filter[key][subKey])
          return true

        if (Array.isArray(filter[key][subKey])) {
          return filter[key][subKey].includes(item[key][subKey]);
        }

        return item[key][subKey] === filter[key][subKey]
      })
    }

    return item[key] === filter[key]
  })
}

const checkCondition = (value, condition) => {
  let result = -1
  if (condition === '!_null')
    result = (value !== null)

  return result
}

const nestedSort = (prop1, prop2 = null, direction = 'asc') => (e1, e2) => {
  const a = prop2 ? e1[prop1][prop2] : e1[prop1],
      b = prop2 ? e2[prop1][prop2] : e2[prop1],
      sortOrder = direction === "asc" ? 1 : -1
  return (a < b) ? -sortOrder : (a > b) ? sortOrder : 0;
}

export const orderBy = (list, order) => {
  if (!list) return []

  return list.sort(nestedSort(order.attr, null, order.direction));
}
